<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-settings">{{
              $t("dashboardCardSuperAdminBasicSettings")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <v-form ref="form" v-model="valid">
              <!-- MODULE SETTINGS -->
              <v-card
                class="#505050--text mb-1"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  <span class="headline">
                    {{ $t("settingsPhotoOrderBasicSettingsTitle") }}
                  </span>
                </v-card-title>
                <v-card-text class="pb-0 mb-0">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.notifyEmail"
                        :label="$t('settingsNotifyEmailText')"
                        :rules="[validateIsEmail(), validateMaxLength(250)]"
                        :counter="250"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12> 
                      <v-text-field
                        v-model="editedItem.taxPct"
                        :label="$t('settingsPhotoOrderBasicTaxTitle')"
                        :rules="[
                          validateRequired(),
                          validateIsPercent(),
                          validateMaxLength(3),
                        ]"
                        :counter="3"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.extraCharge"
                        :label="$t('settingsDeliveryGridHeaderExtraPayTitle')"
                        :rules="[
                          validateRequired(),
                          validateIsCurrency(),
                          validateMaxLength(20),
                        ]"
                        :counter="20"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.extraChargeMessage"
                        :label="
                          $t('settingsDeliveryGridHeaderExtraPayMessageTitle')
                        "
                        :rules="[validateMaxLength(100)]"
                        :counter="100"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.extraChargeFreeOver"
                        :label="
                          $t('settingsDeliveryGridHeaderExtraPayFreeOverTitle')
                        "
                        :rules="[
                          validateRequired(),
                          validateIsCurrency(),
                          validateMaxLength(20),
                        ]"
                        :counter="20"
                        dense
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </v-flex>
          <!-- GUMB NAZAJ -->
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenuModulePhotoGift' })"
          ></simple-navigation-button>
          <!-- GUMB SHRANI -->
          <simple-navigation-button
            :title="$t('addEditFormSaveButton')"
            icon="mdi-content-save"
            @clicked="saveForm"
            right
          ></simple-navigation-button>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";

export default {
  name: "settingsPhotoOrderBasic",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton,
  },
  data() {
    return {
      valid: true,
      netBackImage: require("@/assets/netBack.png"),
      cardMenuImage: require("@/assets/usersNewGift.jpg"),
      editedItem: {
        notifyEmail: this.$store.state.storeClient.client.modules
          .modulePhotoGift.notifyEmail,
        taxPct: this.$store.state.storeClient.client.modules.modulePhotoGift
          .taxPct,
        extraCharge: this.$store.state.storeClient.client.modules
          .modulePhotoGift.extraCharge,
        extraChargeFreeOver: this.$store.state.storeClient.client.modules
          .modulePhotoGift.extraChargeFreeOver,
        extraChargeMessage: this.$store.state.storeClient.client.modules
          .modulePhotoGift.extraChargeMessage,
      },
    };
  },
  methods: {
    async saveForm() {
      if (this.$refs.form.validate()) {
        try {
          let result = await this.$store.dispatch(
            "saveSettingsCustomModuleMainImage",
            {
              modules: {
                modulePhotoGift: {
                  notifyEmail: this.editedItem.notifyEmail,
                  taxPct: this.editedItem.taxPct,
                  extraCharge: this.editedItem.extraCharge,
                  extraChargeFreeOver: this.editedItem.extraChargeFreeOver,
                  extraChargeMessage: this.editedItem.extraChargeMessage,
                },
              },
            }
          );
          if (result) {
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } else {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: this.$t("msgErrorSave"),
            });
          }
        } catch (error) {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: error,
          });
        }
      }
    },
  },
};
</script>
